// import "core-js/es6/array";
// import "core-js/es6/object";
// import "core-js/es6/number";
// import "core-js/es6/promise";
// import "core-js/es6/map";
// import "core-js/es6/reflect";
// import "core-js/stage/pre";
import "core-js";

import "whatwg-fetch";